var map = {
	"./as-IN.json": [
		854,
		[
			854
		]
	],
	"./bn-IN.json": [
		314,
		[
			314
		]
	],
	"./en-IN.json": [
		387,
		[
			387
		]
	],
	"./gu-IN.json": [
		486,
		[
			486
		]
	],
	"./hi-IN.json": [
		839,
		[
			839
		]
	],
	"./kn-IN.json": [
		909,
		[
			290
		]
	],
	"./ml-IN.json": [
		217,
		[
			217
		]
	],
	"./mr-IN.json": [
		783,
		[
			783
		]
	],
	"./or-IN.json": [
		290,
		[
			909
		]
	],
	"./pa-IN.json": [
		735,
		[
			735
		]
	],
	"./ta-IN.json": [
		59,
		[
			59
		]
	],
	"./te-IN.json": [
		975,
		[
			975
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 726;
module.exports = webpackAsyncContext;